import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';
import {
  BodyRegular,
  BodyRegularBold,
  BodyRegularMedium,
  BodySmall,
  BodySmallMedium,
  BodySmallSummary,
  BodyRegularSemiBold,
} from '@src/fonts/typography/Typography';
import { DarkTextColor } from '@src/fonts/typography/TypographyColors';

interface TariffInfoContainerProps {
  hasError: boolean;
  isAvailable: boolean;
}

export const TariffsContainer = styled.div``;

export const TariffItemContainer = styled.div``;

export const TariffItemNameLabel = styled.p`
  ${BodyRegularSemiBold}
  ${DarkTextColor}
`;

export const TariffItemIsDependentLabel = styled.p`
  ${BodySmallSummary}
  margin-left: 16px;
  font-style: italic;
`;

export const TariffItemLabel = styled.div`
  display: flex;
  align-items: center;
`;

export const TariffItemValue = styled.div`
  ${BodyRegular}
`;

export const TariffOldPrice = styled.p`
  ${BodySmall}
  span {
    text-decoration: line-through;
  }
`;
export const TariffPrice = styled.p<{ lineThrough?: boolean }>`
  ${BodyRegularBold}

  ${(props) => (props.lineThrough ? 'text-decoration: line-through;' : '')}
`;

export const TariffQuantityContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-end;
  width: auto;
  flex: 0;
  min-width: 84px;
`;

export const TariffAreaInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TariffDescription = styled.p`
  ${BodySmall}
`;

export const TariffQuantityLabel = styled.p`
  ${BodySmall}
  ${DarkTextColor}
`;

export const TariffSelectInputArea = styled.div`
  width: 100%;
`;

export const TariffInfoContainer = styled.div<TariffInfoContainerProps>`
  background-color: #f6f6f6;
  margin: 16px 0;
  padding: 16px;
  display: flex;
  flex-flow: column;
  gap: 5px 0;
  border-radius: 8px;
  ${(props) => props.hasError && 'border: 1px solid #EB3223;'};
  ${(props) => !props.isAvailable && 'opacity: 0.5;'};
`;

export const UnavailableTariffLabel = styled.div`
  ${BodyRegularMedium};
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
  background: #cdcdcd;
  border-radius: 4px;
  color: #5f5f5f;
  text-align: center;
`;

export const ProductAdderErrorLabel = styled.p`
  ${BodySmallMedium};
  padding: 8px;
  background-color: #ffd2cd;
  border-radius: 4px;
  margin-top: 8px;
  color: #c7372c;
`;

export const RepricingErrorLabel = styled.p`
  ${BodySmallMedium};
  padding: 8px;
  background-color: ${LayoutColors.whiteDark};
  border-radius: 4px;
  margin-top: 8px;
  color: ${LayoutColors.blackMain};
`;
